import { Tooltip } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { BeatLoader, MoonLoader } from "react-spinners";

const TargetList = ({
  generateHandler,
  algoAccess,
  generateLoader,
  isAlgoRunning,
  recommendationLabels,
  onViewProgress,
}) => {
  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const selectedCompany = useSelector((state) => state.CompanyReducer.selected_company);

  // CONST VALS
  const history = useHistory();
  const hasCompanyDetails = selectedCompany?.user_input;

  if (!hasCompanyDetails) {
    return (
      <div className="target-ai-list-container">
        <div className="company-details-required">
          <h3>Company details required</h3>
          <p>
            Please submit your company details first before generating an AI target list.
          </p>
          <p>
            Complete company information helps our AI create more accurate and relevant
            recommendations.
          </p>
          <button onClick={() => history.replace("/company-submission")}>
            Submit company details
          </button>
        </div>
      </div>
    );
  }

  if (isAlgoRunning) {
    return (
      <div className="target-ai-list-container target-ai-list-container--running">
        <div className="florence-running-status">
          <MoonLoader size={28} speedMultiplier={0.55} color="#605bff" />
          <h2>Florence is building your list</h2>
          <p>
            We already started generating ranked{" "}
            {recommendationLabels?.plural?.toLowerCase() || "recommendations"} from your
            company details. This usually takes a few minutes.
          </p>
          <button type="button" onClick={onViewProgress}>
            View progress
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="target-ai-list-container">
      <h2>Generate Florence Recommendations</h2>
      <div className="feature-description">
        <p>
          Florence reviews your company profile and produces ranked{" "}
          {recommendationLabels?.plural?.toLowerCase() || "recommendations"} that are most
          aligned with your strategy.
        </p>
        <ul>
          <li>Prioritizes strategic fit, industry alignment, and target quality</li>
          <li>Summarizes the strongest reasons behind each recommendation</li>
          <li>Creates a review-ready shortlist for your team to action quickly</li>
        </ul>
        <p>
          Generate a fresh list whenever your company details change so the ranking and
          rationale stay current.
        </p>
      </div>
      {algoAccess ? (
        <button onClick={generateHandler} disabled={generateLoader}>
          {generateLoader ? (
            <BeatLoader color="#Fff" size={8} />
          ) : (
            "Generate AI List"
          )}{" "}
        </button>
      ) : (
        <Tooltip
          title={user?.free_trial ? "Free trial limit reached" : "Monthly limit reached"}
        >
          <button disabled>Generate AI List</button>
        </Tooltip>
      )}
    </div>
  );
};

export default TargetList;
